module.exports = __webpack_public_path__ + "static/media/device-far-right-sidebar.79314173.png";